module.exports = __webpack_public_path__ + "static/media/default_button.363466a4.svg";